import axios from 'axios';

export const ApiBaseUrl = import.meta.env.VITE_APP_API_ROOT.substring(0, import.meta.env.VITE_APP_API_ROOT.indexOf('api/'));

const api = axios.create({
  baseURL: import.meta.env.VITE_APP_API_ROOT,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: 'application/json',
  },
});

api.interceptors.request.use(async (config) => {
  // Lazy import to avoid circular dependency
  const { useAuthStore } = await import('../stores/auth');
  const auth = useAuthStore();
  const organizationId = auth.getOrganization.id;

  if (organizationId) {
    config.headers['X-Tenant-Id'] = organizationId;
  }

  config.headers['X-Admin'] = 'true';

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && !window.location.href.match(/\/auth\//)) {
      window.location.href = '/auth/login';
    }

    if (error.response && error.response.status === 403 && error.response.data?.error === 'This organization has been deactivated.' && !window.location.pathname.includes('/auth/deactivated')) {
      window.location.href = '/auth/deactivated';
    }

    return Promise.reject(error);
  },
);

export { api };
